function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVideoType(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 58.73,
    y: 78.79,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.96,
    y: 64.68,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.5,
    y: 64.68,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.6,
    y: 161.24,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.82,
    y: 147.13,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.37,
    y: 147.13,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.79,
    y: 64.68,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.79,
    y: 366.64,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 429.56,
    y: 352.53,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.96,
    y: 366.63,
    width: 26.48,
    height: 11.19,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.92,
    y: 233.49,
    width: 26.48,
    height: 11.19,
    transform: "translate(260.32 478.16) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.69,
    y: 247.6,
    width: 26.48,
    height: 11.19,
    transform: "translate(289.86 506.38) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "459.79 442 450.15 442 450.15 213.33 411.95 129 420.74 125.02 459.79 211.25 459.79 442",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "428.16 196.65 382.94 221.65 382.94 44.66 428.16 69.66 428.16 196.65",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "313.77 54.66 382.94 44.66 382.94 221.65 313.77 211.65 313.77 54.66",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.13 60.43 377.58 51.98 377.58 213.93 319.13 205.48 319.13 60.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "436.71 157.98 428.16 162.98 428.16 109.69 436.71 114.69 436.71 157.98",
    style: {
      fill: "#dbdbdb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-89"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "30.67 442 85.5 441.76 140.34 441.67 250 441.5 359.66 441.67 414.5 441.75 469.33 442 414.5 442.24 359.66 442.33 250 442.5 140.34 442.33 85.5 442.24 30.67 442",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112.82 109.92 110.82 109.92 110.82 81.99 149.81 81.99 149.81 83.99 112.82 83.99 112.82 109.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.81 167.45 110.82 167.45 110.82 136.95 112.82 136.95 112.82 165.45 149.81 165.45 149.81 167.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.1 109.92 231.1 109.92 231.1 83.99 194.11 83.99 194.11 81.99 233.1 81.99 233.1 109.92",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.1 167.45 194.11 167.45 194.11 165.45 231.1 165.45 231.1 136.95 233.1 136.95 233.1 167.45",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "155.33 120.39 153.33 120.39 153.33 111.49 165.47 111.49 165.47 113.49 155.33 113.49 155.33 120.39",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "165.47 137.95 153.33 137.95 153.33 128.31 155.33 128.31 155.33 135.95 165.47 135.95 165.47 137.95",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.59 120.39 188.59 120.39 188.59 113.49 178.45 113.49 178.45 111.49 190.59 111.49 190.59 120.39",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "190.59 137.95 178.45 137.95 178.45 135.95 188.59 135.95 188.59 128.31 190.59 128.31 190.59 137.95",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Camera--inject-89"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 149.59,
    y: 180.57,
    width: 55.87,
    height: 59.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.46,
    y: 180.57,
    width: 70.06,
    height: 59.19,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.02,
    y: 180.57,
    width: 54.54,
    height: 59.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 70.83,
    y: 188.24,
    width: 40.91,
    height: 43.87,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "138.71 234.77 132.08 239.77 118.55 239.77 118.55 180.57 131.91 180.57 138.71 185.57 138.71 234.77",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 138.71,
    y: 188.81,
    width: 53.36,
    height: 42.73,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.83 188.24 79.66 197.07 79.66 224.25 70.83 232.1 70.83 188.24",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "79.66 197.07 70.83 188.24 111.74 188.24 111.74 197.07 79.66 197.07",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "70.83 232.1 79.66 224.25 111.74 224.25 111.74 232.1 70.83 232.1",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,201.41v18.75a15.06,15.06,0,0,1-6.43,4.09H95.47a14,14,0,0,1,.85-27.18h8.14A15.11,15.11,0,0,1,111.74,201.41Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.74,201v19.53a13.61,13.61,0,0,1-5.53,3.7h-9A14.4,14.4,0,0,1,98,197.07h7.42A13.55,13.55,0,0,1,111.74,201Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.1,
    y: 169.71,
    width: 10.86,
    height: 10.86,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.62,
    y: 158.39,
    width: 51.88,
    height: 11.32,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.77,
    y: 153.85,
    width: 56.25,
    height: 20.4,
    rx: 6.74,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.49,
    y: 161.64,
    width: 6.18,
    height: 4.82,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 218.32,
    y: 199.09,
    width: 6.87,
    height: 22.17,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223.41,
    y: 194.62,
    width: 39.02,
    height: 31.1,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.37,
    y: 158.39,
    width: 9.16,
    height: 22.19,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "253.99 165.67 194.37 165.67 194.37 156.52 201.02 150.51 253.99 150.51 253.99 165.67",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "272.01 141.04 253.99 150.51 253.99 165.67 272.01 175.14 272.01 141.04",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 186.34,
    y: 254.4,
    width: 14.63,
    height: 14.63,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.82,
    y: 254.4,
    width: 14.63,
    height: 14.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.5,
    y: 239.77,
    width: 30.96,
    height: 14.63,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.46,
    y: 239.77,
    width: 43.36,
    height: 14.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 190.67,
    y: 315.77,
    width: 15.2,
    height: 14.63,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 205.87,
    y: 315.77,
    width: 21.28,
    height: 14.63,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 181.69,
    y: 330.4,
    width: 22.69,
    height: 7.32,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 204.39,
    y: 330.4,
    width: 31.78,
    height: 7.32,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.1,265.63v50.15H187.21v0c-9.46-.54-17-11.55-17-25.06s7.54-24.51,17-25.05v0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.1,
    cy: 290.7,
    rx: 17.72,
    ry: 25.07,
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 231.1,
    cy: 290.7,
    rx: 14.97,
    ry: 21.19,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "159.09 442 154.44 442 185.54 337.72 197.54 337.72 159.09 442",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "258.35 442 264.33 442 233.24 337.72 219.89 337.72 258.35 442",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.5 442 205.52 442 202.72 337.72 216.06 337.72 211.5 442",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-89"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M349.37,200.39c22.58,27,44.25,81.75,42.39,93.63-2.38,15.19-46.25,45.74-63,59.38-7.79,6.33-39.66-48.91-29.19-52.09C304,300,338.9,279.39,341.2,277.69c4.76-3.51-10.72-38.28-16.24-70.37C321.34,186.24,332.32,180,349.37,200.39Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M303.85,300s-16.25,4.7-22.93,8.34S254.34,334.71,259,339.29c6,5.91,20.09-5,26.29-11.17,0,0,13.92,13.69,25.7,8.08S303.85,300,303.85,300Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.73,353.4c-4.42,4.76-26.56,24.75-34,28.94S265.18,397,261.4,391.68s2.46-8.94,2.46-8.94-10.07,2.95-13.38-2.77,6.58-11,6.58-11-10.56,2.27-13.46-3.68,8-9.58,8-9.58-9.56,2.53-9.89-3.37c-.39-7.11,17.76-9.79,25.59-15,1.78-1.19,34.32-26.67,34.32-26.67Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.63,356c13.34-2,18.83-5.18,28.89-13.86.2-.17.49.08.31.28-9.08,9.39-15.39,14.38-29.14,14.23C250,356.68,250,356.14,250.63,356Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,369.11c13.68-3.29,19.67-6.69,30.87-15,.16-.11.38.14.23.27-10.31,9.08-16.72,13.91-30.82,15.4C255.64,369.84,255.38,369.26,256,369.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.42,382.3c13-4.14,19.74-7.58,29.58-17.05a.25.25,0,0,1,.37.34c-9.1,10.63-17.46,15-29.78,17.09C263.75,382.83,263.6,382.56,264.42,382.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.2,340.37c9.37,1.43,17-7.26,23.45-12.84a.77.77,0,0,1,1.25.26c6.22,5.34,16.54,11.07,24.92,8.91a.2.2,0,0,1,.13.38c-8.67,3.54-19.27-1.27-25.71-7.56-6.53,5.83-14.55,14.21-24.06,10.94A0,0,0,1,1,261.2,340.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.21,285.93l40.3,48.32s24-18.69,31.26-30.9-13-61.31-39.07-97.42-36.85-20.75-29.39,9.12c5.9,23.57,13.57,61.27,13.65,62.56S322.21,285.93,322.21,285.93Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.79,254c.47-.08.94-.12,1.4-.18a2.9,2.9,0,0,1,1.5.15,2.72,2.72,0,0,1,1.7,2.48,2.3,2.3,0,0,0,1.14,2,2.6,2.6,0,0,0,1.23.35c.46.06.93.1,1.4.18-.47.09-.94.13-1.4.19a2.7,2.7,0,0,1-3.12-2.73,2.24,2.24,0,0,0-1.2-2,2.75,2.75,0,0,0-1.25-.31C355.73,254.12,355.26,254.09,354.79,254Zm-22.85-41.89a2.74,2.74,0,0,1,1.24.32,2.27,2.27,0,0,1,1.21,2,2.74,2.74,0,0,0,1.62,2.53,2.69,2.69,0,0,0,1.49.2c.47-.07.93-.1,1.4-.19-.47-.08-.93-.12-1.4-.18a2.6,2.6,0,0,1-1.23-.35,2.31,2.31,0,0,1-1.13-2,2.74,2.74,0,0,0-1.71-2.48,2.87,2.87,0,0,0-1.49-.15c-.47.06-.94.1-1.41.18C331,212,331.47,212.05,331.94,212.11ZM370.73,294a2.82,2.82,0,0,1,1.25.31,2.3,2.3,0,0,1,1.2,2,2.69,2.69,0,0,0,3.11,2.72c.47-.06.94-.1,1.4-.18-.46-.09-.93-.12-1.4-.19a2.75,2.75,0,0,1-1.23-.34,2.32,2.32,0,0,1-1.13-2,2.74,2.74,0,0,0-1.71-2.48,2.87,2.87,0,0,0-1.49-.15c-.47.06-.94.1-1.4.19C369.79,293.93,370.26,294,370.73,294Zm-37-54.95a2.7,2.7,0,0,1-1.1.66,2.26,2.26,0,0,1-1.6-.11l.18.82a2.72,2.72,0,0,0,1.62-.16,2.81,2.81,0,0,0,1.16-.95c.29-.37.59-.73.86-1.12C334.48,238.49,334.13,238.8,333.75,239.08Zm27.54-17a2.74,2.74,0,0,1-.31,1.24,2.29,2.29,0,0,1-2,1.21,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.93.18,1.4.09-.47.13-.93.19-1.4a2.6,2.6,0,0,1,.35-1.23,2.29,2.29,0,0,1,2-1.13,2.74,2.74,0,0,0,2.48-1.71,2.87,2.87,0,0,0,.15-1.49c-.06-.47-.1-.94-.18-1.4C361.39,221.18,361.36,221.65,361.29,222.12Zm-11.14,82.25a2.74,2.74,0,0,1-.31,1.24,2.3,2.3,0,0,1-2,1.21,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.93.18,1.4.09-.47.12-.93.19-1.4a2.75,2.75,0,0,1,.34-1.23,2.32,2.32,0,0,1,2-1.13,2.74,2.74,0,0,0,2.48-1.71,2.87,2.87,0,0,0,.15-1.49c-.06-.47-.1-.94-.19-1.4C350.25,303.43,350.21,303.9,350.15,304.37ZM334.21,185.75a2.47,2.47,0,0,1-.29,1,2.26,2.26,0,0,1-2,1.2,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.94.18,1.41.09-.47.13-.94.19-1.41a2.67,2.67,0,0,1,.34-1.22,2.31,2.31,0,0,1,2-1.14,2.73,2.73,0,0,0,2.48-1.71,2.45,2.45,0,0,0,.17-1.1ZM390,272.1l-.33,0a2.7,2.7,0,0,0-2.72,3.12c.06.46.1.93.18,1.4.09-.47.13-.94.19-1.4a2.6,2.6,0,0,1,.35-1.23,2.3,2.3,0,0,1,2-1.14,2,2,0,0,0,.55-.07Zm-45.72,6.06a2.7,2.7,0,0,1,1.1-.66,2.26,2.26,0,0,1,2.24.54,2.78,2.78,0,0,0,2.94.64,2.68,2.68,0,0,0,1.19-.92c.28-.37.59-.73.86-1.12-.39.27-.75.57-1.12.86a2.66,2.66,0,0,1-1.12.62,2.3,2.3,0,0,1-2.23-.62,2.73,2.73,0,0,0-3-.55,2.81,2.81,0,0,0-1.16.95c-.29.37-.59.73-.86,1.12C343.5,278.75,343.85,278.44,344.23,278.16Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.19 288.58 326.64 282.22 369.97 330.88 357.58 340.87 312.19 288.58",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "312.19 288.58 326.64 282.22 369.97 330.88 357.58 340.87 312.19 288.58",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.73,442h86.9c2.74-29.46,5.49-59.65,7.67-83.72.07-.8.15-1.6.22-2.39,2.46-27.23,4.13-46.05,4.13-46.05h-82a1.79,1.79,0,0,0,0,.25C307,314.55,298.69,379.63,290.73,442Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.46,442h1.38c3.79-31.9,6.87-63.86,9.67-95.86v0q.24-2.87.5-5.75c.56-6.57,1.12-13.17,1.66-19.75,0-.2-.29-.2-.32,0q-.92,8.75-1.78,17.46a.09.09,0,0,0,0,.05c-.2,2.12-.42,4.23-.63,6.36h0c-2.23,22.08-4.44,44.14-6.86,66.19Q366.36,426.37,364.46,442Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.49,309.84l11,72.72h0l.39,2.46v0l1,6.55h0l.08.46.26,1.76h0L339.54,442h46.68c4.79-27,9.69-54.68,13.75-77.65h0c.09-.52.18-1,.27-1.52,5.47-30.91,9.38-53,9.38-53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.57,309.77s0,.1.05.32c.65,4.24,7.71,49.71,19.44,79.55h0c.08.25.17.48.28.74,0,0,1.65.51,4.63,1.69,1.16.46,2.54,1,4.1,1.7h0l1.7.76c3.44,1.54,7.61,3.56,12.37,6.14.46.24.91.49,1.36.74,0,0,0,.19,0,.54h0c.24,3.13,1.46,19.19,3,40h81.79c-6.3-64.93-13.22-132.23-13.22-132.23Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414,322.42c2.33,30.46,4.56,60.92,7,91.34q1.14,14.12,2.34,28.24h1.2q-5.19-59.78-9.87-119.56C414.63,322,414,322,414,322.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.21,388.24a180.07,180.07,0,0,1,28.3,13.18.32.32,0,0,1-.26.59c-9.54-4.1-19.26-8-28.55-12.63A.62.62,0,0,1,323.21,388.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.18,322.82c0-.33.6-.4.6,0a318.17,318.17,0,0,0,1.6,31.85c.44,4.91,4.39,32.05,12.91,30.07,1.42-.33,2.15-1.73,2.38-3.88.26-2.58-.71-5.75-1.13-8.32-1-5.69-1.71-11.39-2.2-17.12a155.92,155.92,0,0,1,.35-32.11.28.28,0,0,1,.55,0c0,14.83.37,29.63,2.59,44.32,1.07,7.06,4.62,17.69-2.76,18.77s-12.38-16.69-13.3-21.56C319.21,351.24,319.11,336.57,320.18,322.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.06,385.43a46.67,46.67,0,0,1,1.92,5.63,12.69,12.69,0,0,1,.79,4.62c0,.3-.43.33-.59.13a16.33,16.33,0,0,1-2-4.5c-.65-1.74-1.34-3.47-1.94-5.23A1,1,0,0,1,335.06,385.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.6,331.7a14.82,14.82,0,0,1,.36-3.52.18.18,0,0,1,.34,0,13.4,13.4,0,0,1,.4,3c.12,1.17.27,2.33.4,3.5a49.86,49.86,0,0,0,1.25,7.09,25.21,25.21,0,0,0,6.5,11.69,34,34,0,0,0,11,7.24c4.57,1.94,9.38,2.66,14.11,4.05.2.05.14.34-.06.35a41,41,0,0,1-15.28-3,32.79,32.79,0,0,1-11.47-7.32,25.58,25.58,0,0,1-6.69-12,36.14,36.14,0,0,1-.91-7.11A31.26,31.26,0,0,1,373.6,331.7Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.14,354.49l135.93-8.86S410,228.34,347.13,184.11c-11.32-8-31.09,2.4-34.15,12C298.66,241.18,297.73,354.08,298.14,354.49Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.79,254c.47-.08.94-.12,1.4-.18a2.9,2.9,0,0,1,1.5.15,2.72,2.72,0,0,1,1.7,2.48,2.3,2.3,0,0,0,1.14,2,2.6,2.6,0,0,0,1.23.35c.46.06.93.1,1.4.18-.47.09-.94.13-1.4.19a2.7,2.7,0,0,1-3.12-2.73,2.24,2.24,0,0,0-1.2-2,2.75,2.75,0,0,0-1.25-.31C355.73,254.12,355.26,254.09,354.79,254Zm28.77,92.53a2.85,2.85,0,0,0-1.49-.15c-.47.06-.93.1-1.4.18.47.08.93.12,1.4.18a2.75,2.75,0,0,1,1.25.32,2.29,2.29,0,0,1,1.19,1.8l.74-.05A2.7,2.7,0,0,0,383.56,346.53ZM331.94,212.11a2.74,2.74,0,0,1,1.24.32,2.27,2.27,0,0,1,1.21,2,2.74,2.74,0,0,0,1.62,2.53,2.69,2.69,0,0,0,1.49.2c.47-.07.93-.1,1.4-.19-.47-.08-.93-.12-1.4-.18a2.6,2.6,0,0,1-1.23-.35,2.31,2.31,0,0,1-1.13-2,2.74,2.74,0,0,0-1.71-2.48,2.87,2.87,0,0,0-1.49-.15c-.47.06-.94.1-1.41.18C331,212,331.47,212.05,331.94,212.11Zm-12.44,80.8a2.87,2.87,0,0,1,1.24.31,2.3,2.3,0,0,1,1.21,2,2.74,2.74,0,0,0,1.62,2.53,2.69,2.69,0,0,0,1.49.2c.47-.07.93-.1,1.4-.19-.47-.08-.93-.12-1.4-.18a2.6,2.6,0,0,1-1.23-.35,2.32,2.32,0,0,1-1.14-2,2.73,2.73,0,0,0-1.7-2.49,3,3,0,0,0-1.49-.14c-.47.06-.94.09-1.41.18C318.56,292.81,319,292.85,319.5,292.91Zm28.05,39.24a2.88,2.88,0,0,1,1.25.31,2.27,2.27,0,0,1,1.2,2,2.76,2.76,0,0,0,1.62,2.53,2.79,2.79,0,0,0,1.5.19c.46-.06.93-.1,1.4-.18-.47-.09-.94-.12-1.4-.18a2.68,2.68,0,0,1-1.23-.35,2.3,2.3,0,0,1-1.14-2,2.74,2.74,0,0,0-1.71-2.49,2.85,2.85,0,0,0-1.49-.15c-.46.07-.93.1-1.4.19C346.62,332.05,347.09,332.09,347.55,332.15Zm-44.78,12.92a2.75,2.75,0,0,1-1.23-.35,2.31,2.31,0,0,1-1.13-2,2.74,2.74,0,0,0-1.71-2.49,1.82,1.82,0,0,0-.52-.14v.54l.28.13a2.31,2.31,0,0,1,1.2,2,2.69,2.69,0,0,0,3.11,2.72c.47-.06.94-.1,1.4-.18C303.71,345.16,303.24,345.13,302.77,345.07Zm68-51a2.82,2.82,0,0,1,1.25.31,2.3,2.3,0,0,1,1.2,2,2.69,2.69,0,0,0,3.11,2.72c.47-.06.94-.1,1.4-.18-.46-.09-.93-.12-1.4-.19a2.75,2.75,0,0,1-1.23-.34,2.32,2.32,0,0,1-1.13-2,2.74,2.74,0,0,0-1.71-2.48,2.87,2.87,0,0,0-1.49-.15c-.47.06-.94.1-1.4.19C369.79,293.93,370.26,294,370.73,294Zm-37-54.95a2.7,2.7,0,0,1-1.1.66,2.26,2.26,0,0,1-2.24-.54,2.78,2.78,0,0,0-2.94-.64,2.74,2.74,0,0,0-1.19.92c-.28.37-.59.73-.86,1.12.39-.27.75-.57,1.12-.86a2.66,2.66,0,0,1,1.12-.62,2.3,2.3,0,0,1,2.23.62,2.73,2.73,0,0,0,3,.55,2.81,2.81,0,0,0,1.16-.95c.29-.37.59-.73.86-1.12C334.48,238.49,334.13,238.8,333.75,239.08Zm-18.69-31.26a2.92,2.92,0,0,1-1.11.66,2.28,2.28,0,0,1-2.24-.54,2.78,2.78,0,0,0-1.69-.81l-.15.67a2.23,2.23,0,0,1,1.32.68,2.75,2.75,0,0,0,3,.55,2.93,2.93,0,0,0,1.15-.95c.29-.38.6-.73.87-1.13C315.79,207.23,315.43,207.53,315.06,207.82Zm94.34,85.7a2.81,2.81,0,0,1-1.1.66,2.28,2.28,0,0,1-2.24-.54,2.77,2.77,0,0,0-2.94-.65,2.82,2.82,0,0,0-1.19.92c-.28.38-.59.73-.86,1.13.39-.28.75-.58,1.12-.87a2.66,2.66,0,0,1,1.12-.62,2.3,2.3,0,0,1,2.23.63,2.73,2.73,0,0,0,3,.55,2.89,2.89,0,0,0,1.16-1c.29-.38.59-.73.87-1.12C410.13,292.93,409.78,293.23,409.4,293.52Zm-52.88-102a2.11,2.11,0,0,0-.61.16,2.72,2.72,0,0,0-1.19.91c-.28.38-.59.74-.86,1.13.39-.27.75-.58,1.12-.87a2.78,2.78,0,0,1,1.12-.62,2.32,2.32,0,0,1,1.28,0C357.1,192,356.81,191.73,356.52,191.49Zm4.77,30.63a2.74,2.74,0,0,1-.31,1.24,2.29,2.29,0,0,1-2,1.21,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.93.18,1.4.09-.47.13-.93.19-1.4a2.6,2.6,0,0,1,.35-1.23,2.29,2.29,0,0,1,2-1.13,2.74,2.74,0,0,0,2.48-1.71,2.87,2.87,0,0,0,.15-1.49c-.06-.47-.1-.94-.18-1.4C361.39,221.18,361.36,221.65,361.29,222.12Zm-11.14,82.25a2.74,2.74,0,0,1-.31,1.24,2.3,2.3,0,0,1-2,1.21,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.93.18,1.4.09-.47.12-.93.19-1.4a2.75,2.75,0,0,1,.34-1.23,2.32,2.32,0,0,1,2-1.13,2.74,2.74,0,0,0,2.48-1.71,2.87,2.87,0,0,0,.15-1.49c-.06-.47-.1-.94-.19-1.4C350.25,303.43,350.21,303.9,350.15,304.37Zm-45.34,2.94a2.92,2.92,0,0,1-.31,1.25,2.31,2.31,0,0,1-2,1.2,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.94.18,1.41.09-.47.12-.94.18-1.41a2.75,2.75,0,0,1,.35-1.23,2.31,2.31,0,0,1,2-1.13A2.74,2.74,0,0,0,305,308.8a2.85,2.85,0,0,0,.15-1.49c-.07-.47-.1-.93-.19-1.4C304.91,306.38,304.87,306.84,304.81,307.31Zm2.87-73.8c-.07-.47-.1-.94-.19-1.41-.08.47-.12.94-.18,1.41a2.87,2.87,0,0,1-.31,1.24,2.31,2.31,0,0,1-1.94,1.21c0,.25-.07.5-.1.75h.09a2.74,2.74,0,0,0,2.48-1.71A2.87,2.87,0,0,0,307.68,233.51Zm26.55-48a2.75,2.75,0,0,1-.31,1.25,2.26,2.26,0,0,1-2,1.2,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.94.18,1.41.09-.47.13-.94.19-1.41a2.67,2.67,0,0,1,.34-1.22,2.31,2.31,0,0,1,2-1.14,2.73,2.73,0,0,0,2.48-1.71,2.85,2.85,0,0,0,.15-1.49c-.06-.47-.1-.93-.18-1.4C334.33,184.6,334.29,185.06,334.23,185.53ZM327,259.7a2.75,2.75,0,0,1-.32,1.25,2.24,2.24,0,0,1-2,1.2,2.7,2.7,0,0,0-2.73,3.12c.06.46.1.93.19,1.4.08-.47.12-.94.18-1.4a2.6,2.6,0,0,1,.35-1.23,2.3,2.3,0,0,1,2-1.14,2.72,2.72,0,0,0,2.48-1.7,2.9,2.9,0,0,0,.15-1.5c-.06-.46-.1-.93-.18-1.4C327.1,258.77,327.07,259.24,327,259.7Zm64.89,10a2.74,2.74,0,0,1-.31,1.24,2.26,2.26,0,0,1-2,1.2,2.7,2.7,0,0,0-2.72,3.12c.06.46.1.93.18,1.4.09-.47.13-.94.19-1.4a2.6,2.6,0,0,1,.35-1.23,2.3,2.3,0,0,1,2-1.14,2.72,2.72,0,0,0,2.48-1.7,2.87,2.87,0,0,0,.15-1.49c-.06-.47-.1-.94-.18-1.41C392,268.74,392,269.21,391.9,269.68Zm-59.79,81.88c-.05.24-.08.48-.11.72h.21C332.18,352,332.15,351.8,332.11,351.56ZM413.63,317a3,3,0,0,1-.31,1.25,2.31,2.31,0,0,1-2,1.2,2.75,2.75,0,0,0-2.53,1.62,2.69,2.69,0,0,0-.2,1.49c.07.47.1.94.19,1.4.08-.46.12-.93.18-1.4a2.63,2.63,0,0,1,.35-1.23,2.31,2.31,0,0,1,2-1.13,2.73,2.73,0,0,0,2.48-1.71A2.85,2.85,0,0,0,414,317c-.06-.47-.1-.94-.18-1.4C413.73,316.1,413.69,316.57,413.63,317Zm-32.38-76.11a2.8,2.8,0,0,1,1.11-.66,2.27,2.27,0,0,1,2.24.54,2.73,2.73,0,0,0,2.93.64,2.68,2.68,0,0,0,1.19-.92c.29-.37.59-.73.86-1.12-.39.27-.74.58-1.12.86a2.7,2.7,0,0,1-1.11.63,2.32,2.32,0,0,1-2.23-.63,2.75,2.75,0,0,0-3-.55,3,3,0,0,0-1.16.95c-.28.37-.59.73-.86,1.12C380.52,241.52,380.88,241.21,381.25,240.93Zm-37,37.23a2.7,2.7,0,0,1,1.1-.66,2.26,2.26,0,0,1,2.24.54,2.78,2.78,0,0,0,2.94.64,2.68,2.68,0,0,0,1.19-.92c.28-.37.59-.73.86-1.12-.39.27-.75.57-1.12.86a2.66,2.66,0,0,1-1.12.62,2.3,2.3,0,0,1-2.23-.62,2.73,2.73,0,0,0-3-.55,2.81,2.81,0,0,0-1.16.95c-.29.37-.59.73-.86,1.12C343.5,278.75,343.85,278.44,344.23,278.16Zm-25.65,50.51a2.81,2.81,0,0,1,1.1-.66,2.28,2.28,0,0,1,2.24.54,2.69,2.69,0,0,0,4.13-.27c.29-.38.59-.73.86-1.12-.39.27-.74.57-1.12.86a2.57,2.57,0,0,1-1.11.62,2.32,2.32,0,0,1-2.24-.63,2.71,2.71,0,0,0-3-.54,2.86,2.86,0,0,0-1.16.94c-.28.38-.59.74-.86,1.13C317.85,329.26,318.21,329,318.58,328.67Zm60.72-5.19a2.81,2.81,0,0,1,1.1-.66,2.26,2.26,0,0,1,2.24.54,2.73,2.73,0,0,0,2.93.64,2.77,2.77,0,0,0,1.2-.92c.28-.37.59-.73.86-1.12-.39.27-.75.58-1.12.86a2.69,2.69,0,0,1-1.12.63,2.3,2.3,0,0,1-2.23-.63,2.73,2.73,0,0,0-3-.55,2.81,2.81,0,0,0-1.16,1c-.29.38-.6.73-.87,1.12C378.56,324.07,378.92,323.77,379.3,323.48Zm34.15,20.91a2.8,2.8,0,0,1,1.11-.66,2.26,2.26,0,0,1,2.24.54,2.71,2.71,0,0,0,4.13-.28c.28-.37.59-.73.86-1.12-.39.27-.75.57-1.12.86a2.66,2.66,0,0,1-1.12.62,2.3,2.3,0,0,1-2.23-.62,2.75,2.75,0,0,0-3-.55,2.85,2.85,0,0,0-1.15.95c-.29.37-.6.73-.87,1.12C412.72,345,413.08,344.67,413.45,344.39ZM306.1,278.69a2.66,2.66,0,0,1-1.12.62,2.3,2.3,0,0,1-2.23-.62,2.77,2.77,0,0,0-1.81-.77c0,.23,0,.45-.05.68a2.27,2.27,0,0,1,1.34.63,2.78,2.78,0,0,0,2.94.64,2.82,2.82,0,0,0,1.19-.92c.28-.37.59-.73.86-1.12C306.83,278.1,306.47,278.4,306.1,278.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.15,152c.39,7.82-4.85,14.44-11.72,14.79s-12.74-5.73-13.13-13.55,4.86-14.44,11.72-14.78S296.76,144.2,297.15,152Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.2,152.32c.44,8.7-5.4,16.06-13,16.44S274,162.4,273.56,153.69s5.4-16.06,13-16.44S300.77,143.61,301.2,152.32Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324,215.2c8-.65,17-16.08,19-26.87.13-.74-3-7.05-6.4-14.9-2.06-4.77-4.23-10.13-5.87-15.16-.33-1-29.08,17.91-29.08,17.91s6.53,9.55,9.32,18.34a11.69,11.69,0,0,1,.45,2.14c0,.1,0,.22.07.36C312.15,201.15,316.28,215.83,324,215.2Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.82,196.13a19.85,19.85,0,0,1-3.3.88c0-.13,0-.25-.07-.36a10.82,10.82,0,0,0-.45-2.13c-2.8-8.79-9.32-18.34-9.32-18.34S325,160.8,329.89,158.51C330.8,164.64,333.3,189.68,314.82,196.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M326.43,122.09c6.25,10.6,8.18,45.12,1.81,54.45-9.22,13.52-28.29,19.2-40.78,7.21-12.12-11.63-13.83-56.65-6.35-65.54C292.12,105.12,317.2,106.44,326.43,122.09Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.94,151.13c0-.08-.17.13-.15.22.3,2.31.26,5-1.76,6-.06,0,0,.14,0,.13C286.59,156.85,286.6,153.27,285.94,151.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.63,148.92c-3.75.09-3.3,7.59.18,7.51S286.78,148.84,283.63,148.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.72,143.76c-1-.16-2-.47-3-.73a5,5,0,0,1-2.91-1.33,1.58,1.58,0,0,1,.06-1.94c1-1.11,2.52-1.1,3.91-.8a5.79,5.79,0,0,1,3.57,2.16A1.7,1.7,0,0,1,304.72,143.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.36,145.44a29.54,29.54,0,0,0,2.9-1.06,5,5,0,0,0,2.74-1.66,1.58,1.58,0,0,0-.28-1.92c-1.14-1-2.62-.8-4-.34a5.77,5.77,0,0,0-3.3,2.55A1.69,1.69,0,0,0,280.36,145.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.22,170.57c-.5.6-1,1.4-1.81,1.55a6.17,6.17,0,0,1-2.55-.33.08.08,0,0,0-.09.13,3.13,3.13,0,0,0,3.07,1,2.47,2.47,0,0,0,1.62-2.23C304.48,170.51,304.3,170.48,304.22,170.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.1,163.88a7.92,7.92,0,0,1-4.92,4,9.87,9.87,0,0,1-2.82.42,3.33,3.33,0,0,1-.55,0l-.52,0a.57.57,0,0,1-.51-.47v0a1,1,0,0,1,0-.24h0v-.21c-.23-1.78-.33-4.51-.33-4.51-.62.4-3.79,2.22-3.83,1.28-.31-7.76-.66-16.39.67-24.17a.22.22,0,0,1,.43,0c.6,7.45-.12,15,.35,22.44a13.74,13.74,0,0,1,3.61-1.5c.26.05.1,5.28.26,6.07l0,.08c3,.08,5.2-1,7.91-3.35C301,163.54,301.22,163.68,301.1,163.88Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.68,149.57a7.63,7.63,0,0,0-2-.13,7.72,7.72,0,0,0-2,.46,6,6,0,0,0-1.85,1.18,5,5,0,0,0-1.2,1.91l-.46,1.3,1.35-.36a15.27,15.27,0,0,1,2.9-.48,6.16,6.16,0,0,1,3,.52,4.39,4.39,0,0,0-2.9-1.59,8.44,8.44,0,0,0-3.39.16l.89.93a5,5,0,0,1,2.21-2.46A15.89,15.89,0,0,1,305.68,149.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.67,155.63a12.42,12.42,0,0,1-3.14-.63c-.23-.1-1.16-.57-1.14-.75a6,6,0,0,1,.28-1.56,4.08,4.08,0,0,0-.6,1.57,2.1,2.1,0,0,0,1.29,1.19A6.4,6.4,0,0,0,302.67,155.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.78,144.68c-3-6.48-.33-18.14-4-20.8-8-5.77-21.51,8.32-31.71,9.46-9.89,1.11-13.87-4.91-12.93-13.13s7.19-14.33,18.12-17.16c11.31-2.93,22.27.6,28.35,3.65,0,0-2.92-3.75-2.12-5.09s6.06,2,7.72,3.48a14.94,14.94,0,0,1,2.92,4.52,16.05,16.05,0,0,1,4.47-1c2.52-.2,5.9,1.44,6.14,2s-3.31,1.41-5.82,1.81c0,0,5.37,5.75,5.83,11.11s-5.18,31.66-7.15,32.14C327.06,156.36,321,147.31,319.78,144.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.87,111.93c-.09,0-.2.09-.1.16a17.06,17.06,0,0,1,6.15,7,21.23,21.23,0,0,1,1.27,11c-.83,7.19-3.59,13.93-5.89,20.73-.07.2.27.32.35.12,2.9-7.05,5.8-14.67,6.36-22.33C338.49,122.1,336.23,114.88,329.87,111.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.9,121.24a24.46,24.46,0,0,0-8.92,1.53c-2.72,1-4.93,3-7.29,4.62-5.3,3.65-11.22,6.67-17.76,7-.08,0-.07.12,0,.13,6,.11,11.64-2.26,16.63-5.45,2.52-1.6,4.83-3.76,7.53-5,3.07-1.47,6.5-1.79,9.83-2.2A.27.27,0,0,0,315.9,121.24Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.65,152s5.14-12.39,10.6-10.78,3.24,18.41-2,21.8a6,6,0,0,1-8.48-1.41Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.5,146.06c.09,0,.13.1.06.15-3.65,2.51-4.95,6.69-5.58,10.87.87-1.75,2.31-2.92,4.62-1.93.12,0,0,.23-.07.23a3.66,3.66,0,0,0-3.66,2.12,17.88,17.88,0,0,0-1.19,3.6c-.1.4-.79.35-.75-.09,0,0,0-.07,0-.1C325.72,155.81,328.12,147.78,333.5,146.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.76,142.2s1.31-18-3.74-27.37c-5.62-10.47-16.13-13.9-28-12.86,0,0,10.9.33,19.8,12.18,4.78,6.35,6.24,28.53,6.24,28.53Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.79,150.92c-.05,8.71,6.11,15.81,13.75,15.85s13.88-7,13.93-15.7-6.11-15.81-13.76-15.85S314.84,142.21,314.79,150.92Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.82,150.44c0,7.84,5.5,14.21,12.37,14.25s12.47-6.28,12.52-14.11-5.5-14.21-12.37-14.25S318.87,142.61,318.82,150.44Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.6,150.62c0,4.82,3.37,8.74,7.59,8.76s7.67-3.86,7.7-8.68-3.38-8.73-7.6-8.75S325.62,145.81,325.6,150.62Z",
    style: {
      fill: "#37474f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.46,163.35c-4.44-8.16-3.54-22.58-10.31-21.21-6,1.22-5.7,11.27-5.7,11.27s-4-11.2-10.16-8-3.49,14.09-3.49,14.09-4.27-10.1-10.15-6.51-4,13.92-4,13.92-2.7-2.13-5.72,2.27c-4.31,6.3,1.12,21.77,5.18,29.64,9.67,18.72,26.76,32.09,30.24,35.78l49-28.7s-1.83-17.24-3.82-25.87-16.46-35.24-23.3-32.1,3.69,21.76,5.27,26.88.66,6.36-1.84,4.61C211,178.24,203.42,167,201.46,163.35Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.71,153.87c1.47,14,4.53,19.82,13.09,30.68.17.21-.11.51-.31.3-9.35-9.86-14.24-16.66-13.46-30.94C185.07,153.21,185.64,153.21,185.71,153.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.88,158.86c2.79,14.38,6.05,20.76,14.18,32.78.12.18-.16.39-.29.22-9-11.13-13.69-18-14.6-32.74C171.13,158.45,171.75,158.21,171.88,158.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.77,167c3.71,13.72,7,20.87,16.38,31.54a.26.26,0,0,1-.37.36C163.14,189,159,180.08,157.37,167.17,157.26,166.29,157.54,166.15,157.77,167Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.33,234.57c6.9,7.34,65.86,65.38,89.83,65.51S348.62,227.67,355,212.9s-2-24.74-17.44-13.81-57.55,45.61-60.22,45.69-32.77-33.93-41-38.91S183.91,230.94,187.33,234.57Z",
    style: {
      fill: "rgb(247, 169, 160)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.49,229.68,236,286.3s26.89,14.16,41,15.78,50.52-37.12,72.73-75.7,3.74-42.12-20.41-23c-19.06,15.07-50.26,37.57-51.4,38.18S263.49,229.68,263.49,229.68Z",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.53,211.93c.47-.08.94-.12,1.41-.18a2.87,2.87,0,0,1,1.49.15,2.74,2.74,0,0,1,1.71,2.48,2.31,2.31,0,0,0,1.13,2,2.6,2.6,0,0,0,1.23.35c.47.06.93.1,1.4.18-.47.09-.93.12-1.4.19a2.69,2.69,0,0,1-1.49-.2,2.74,2.74,0,0,1-1.62-2.53,2.27,2.27,0,0,0-1.21-2,2.74,2.74,0,0,0-1.24-.32C331.47,212.05,331,212,330.53,211.93Zm-69,58.21a2.88,2.88,0,0,1,1.25.31,2.27,2.27,0,0,1,1.2,2,2.76,2.76,0,0,0,1.62,2.53,2.7,2.7,0,0,0,1.5.19c.46-.06.93-.09,1.4-.18-.47-.09-.94-.12-1.4-.18a2.57,2.57,0,0,1-1.23-.35,2.3,2.3,0,0,1-1.14-2,2.73,2.73,0,0,0-1.71-2.49,2.85,2.85,0,0,0-1.49-.14c-.46.06-.93.09-1.4.18C260.62,270,261.09,270.08,261.55,270.14Zm72.2-31.06a2.7,2.7,0,0,1-1.1.66,2.26,2.26,0,0,1-2.24-.54,2.78,2.78,0,0,0-2.94-.64,2.74,2.74,0,0,0-1.19.92c-.28.37-.59.73-.86,1.12.39-.27.75-.57,1.12-.86a2.66,2.66,0,0,1,1.12-.62,2.3,2.3,0,0,1,2.23.62,2.73,2.73,0,0,0,3,.55,2.81,2.81,0,0,0,1.16-.95c.29-.37.59-.73.86-1.12C334.48,238.49,334.13,238.8,333.75,239.08Zm-43,18.62a2.81,2.81,0,0,1-1.1.66,2.28,2.28,0,0,1-2.24-.54,2.75,2.75,0,0,0-2.94-.64,2.66,2.66,0,0,0-1.19.91c-.29.38-.59.74-.86,1.13.39-.27.75-.58,1.12-.87a2.68,2.68,0,0,1,1.11-.62,2.32,2.32,0,0,1,2.24.63,2.73,2.73,0,0,0,3,.55,3,3,0,0,0,1.16-1c.29-.38.59-.73.86-1.12C291.44,257.11,291.09,257.41,290.71,257.7Zm-45,25.48a2.7,2.7,0,0,1-1.1.66,2.26,2.26,0,0,1-2.24-.54,2.75,2.75,0,0,0-2.94-.64,2.68,2.68,0,0,0-1.19.92c-.29.37-.59.73-.86,1.12.39-.27.74-.58,1.12-.86a2.7,2.7,0,0,1,1.11-.63,2.35,2.35,0,0,1,2.24.63,2.73,2.73,0,0,0,3,.55,2.88,2.88,0,0,0,1.16-.95c.28-.37.59-.73.86-1.12C246.45,282.59,246.09,282.9,245.72,283.18Zm109.19-90.84a2,2,0,0,0-.19.22c-.28.38-.59.74-.86,1.13.39-.27.75-.58,1.12-.87a3.22,3.22,0,0,1,.45-.33A4.44,4.44,0,0,0,354.91,192.34Zm-47.6,41.17a2.87,2.87,0,0,1-.31,1.24,2.3,2.3,0,0,1-2,1.21,2.69,2.69,0,0,0-2.72,3.11c.06.47.1.93.18,1.4.09-.47.12-.93.19-1.4a2.71,2.71,0,0,1,.34-1.23,2.32,2.32,0,0,1,2-1.13,2.74,2.74,0,0,0,2.48-1.71,2.87,2.87,0,0,0,.15-1.49c-.07-.47-.1-.94-.19-1.41C307.41,232.57,307.37,233,307.31,233.51Zm17.42,28.64a2.7,2.7,0,0,0-2.73,3.12c0,.26.06.53.1.8l.21-.26.06-.54a2.6,2.6,0,0,1,.35-1.23,2.3,2.3,0,0,1,2-1.14c.23-.28.46-.56.68-.85A2,2,0,0,1,324.73,262.15Zm2.46-3.85c-.09.47-.12.94-.18,1.4l0,.31.37-.47C327.3,259.13,327.26,258.72,327.19,258.3Zm-63.73-17.49a2.88,2.88,0,0,1-.31,1.25,2.27,2.27,0,0,1-2,1.2,2.76,2.76,0,0,0-2.53,1.62,2.7,2.7,0,0,0-.19,1.5c.06.46.09.93.18,1.4.08-.47.12-.94.18-1.4a2.57,2.57,0,0,1,.35-1.23,2.3,2.3,0,0,1,2-1.14,2.73,2.73,0,0,0,2.49-1.71,3,3,0,0,0,.14-1.49c-.06-.46-.09-.93-.18-1.4C263.56,239.88,263.52,240.35,263.46,240.81ZM280,287.92a2.87,2.87,0,0,1-.31,1.24,2.3,2.3,0,0,1-2,1.21,2.74,2.74,0,0,0-2.53,1.62,2.69,2.69,0,0,0-.2,1.49c.07.47.1.93.19,1.4.08-.47.12-.93.18-1.4a2.6,2.6,0,0,1,.35-1.23,2.31,2.31,0,0,1,2-1.13,2.76,2.76,0,0,0,2.49-1.71,3,3,0,0,0,.14-1.49c-.06-.47-.09-.94-.18-1.41C280.07,287,280,287.45,280,287.92Zm18.92-8.57a2.7,2.7,0,0,1,1.1-.66,2.26,2.26,0,0,1,2.24.54,2.78,2.78,0,0,0,2.94.64,2.82,2.82,0,0,0,1.19-.92c.28-.37.59-.73.86-1.12-.39.27-.75.57-1.12.86a2.66,2.66,0,0,1-1.12.62,2.3,2.3,0,0,1-2.23-.62,2.72,2.72,0,0,0-3-.55,2.81,2.81,0,0,0-1.16.95c-.29.37-.59.73-.86,1.12C298.16,279.94,298.51,279.63,298.89,279.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.78,230.21c.14-.22-.18-.4-.33-.21-6.48,8.11-12.81,16.36-19.48,24.31s-13.3,15.64-20.08,23.34q-2.79,3.17-5.58,6.3c-2,2.23-3.76,4.66-5.83,6.79-.15.16.08.41.24.25,1.83-1.88,3.9-3.52,5.78-5.36s3.57-3.61,5.34-5.44c3.57-3.73,7.11-7.52,10.49-11.42,5.66-6.54,11.06-13.32,16.33-20.18.51-.42,1-.82,1.52-1.26,1-.91,2-1.82,3-2.75a70.41,70.41,0,0,0,5.73-5.86.19.19,0,0,0-.26-.27c-2.07,1.76-4.07,3.65-6,5.54-.56.55-1.13,1.09-1.7,1.63.21-.28.44-.55.65-.83Q346,237.68,350.78,230.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.95 221.65 268.7 232.19 242.17 291.71 227.97 284.53 256.95 221.65",
    style: {
      fill: "#009595"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "256.95 221.65 268.7 232.19 242.17 291.71 227.97 284.53 256.95 221.65",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M307.71,219.9a46.65,46.65,0,0,1,10.87-8.19,47.21,47.21,0,0,1-10.87,8.19Z",
    style: {
      fill: "#263238"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoType);
export default __webpack_public_path__ + "static/media/video-type.f4913efbe4b2dae1f44d3ba1710fcf3b.svg";
export { ForwardRef as ReactComponent };